module.exports = __webpack_public_path__ + "static/assets/9e32994e371028645656c0bce61be484.png";